<div class="article-fixed-head">
  <article-top-navigation [article]="article"
    [multilayerPlan]="multilayerPlan"
    [events]="eventsSubject.asObservable()">
  </article-top-navigation>

  <article-top [edit]="false" [article]="article"></article-top>
</div>

@if (article.date_deleted || article.locked) {
  <div class="row top-buffer">
    <div class="col-lg-12">
      <div class="alert alert-danger" role="alert">
        @if (article.date_deleted) {
          <div><span class="bold">Artikel wurde gelöscht!</span>
          Bearbeitung nicht möglich!
        </div>
      }
      @if (article.locked) {
        <div><span class="bold">Artikel wurde gesperrt!</span>
        Bearbeitung nicht möglich!
      </div>
    }
  </div>
</div>
</div>
}


<div class="row top-buffer">
  <div class="col-md-6">
    <div class="row">
      <div class="col-md-2"> Ausführung: <strong>{{ article.data.execution }}</strong></div>
      <div class="col-md-7">
        @if (validExecution && ('article.extra'|HasPerm)) {
          <div class="inline-block">
            <button type="button" class="btn btn-sm btn-default" (click)="addAll()">
              Schritte gem. Ausführung hinzufügen
            </button>
          </div>

          <div class="inline-block">
            <article-production-step-copy-react [article]="article" (updateList)="reloadList()">
            </article-production-step-copy-react>
          </div>
        }
      </div>

      <div class="col-md-3">
        <ev-file-button [url]="'/api/v1/article/production/' + article.oa_nr + '/pdf/'" [link]="false"
          title="Vorschau Fertigungsliste">
          Vorschau Fertigungsliste
        </ev-file-button>
      </div>
    </div>
  </div>
  <div class="col-md-6">
    @if (!validHash && articleProductionList.length > 0) {
      <div class="label label-danger red_alert mid-label">
        <strong>Achtung!</strong> Artikel wurde geändert. Fertigungsliste muss freigegeben werden.
        @if (('article.extra'|HasPerm)) {
          <button type="button" class="ev-button link-blue" (click)="setHash()">
            Fertigungsliste freigeben
          </button>
        }
      </div>
    }
  </div>
</div>

<div class="row top-buffer">

  <div class="col-md-8">
    <h4>Ausgewählte Fertigungsschritte</h4>
    <table class="table whitetable">
      <thead>
        <tr>
          <th style="width: 50px">Nr.</th>
          <th>Bezeichnung</th>
          <th style="width: 65px;">Dauer</th>
          <th style="width: 105px;">Max-Dauer</th>
          <th style="width: 30px;">&nbsp;</th>
          <th style="width: 125px;">&nbsp;</th>
          <th style="width: 80px;">&nbsp;</th>
          <th style="width: 35px;">&nbsp;</th>
        </tr>
      </thead>
      <tbody>

        <tr dnd-droppable
          [dropZones]="zones"
          (dropSuccessEmitter)="dropStep($event, 1)">
          <td colspan="8" style="padding: 0; border: none;">
            @if (dragging) {
              <div class="-mt-10 h-10 w-full"></div>
            }
          </td>
        </tr>

        @for (obj of articleProductionList; track obj; let index = $index) {
          <tr dnd-draggable
            [dropZones]="zones"
            [dragData]="{data: obj, typ: 'article_production_step'}"
            (dragStartEmitter)="dragStart($event)"
            (dragEndEmitter)="dragEnd($event)">
            <td>{{ obj.production.nr }}</td>
            <td>
              {{ obj.production.text }}
              @if (obj.article.infoText) {
                <span class="label label-info">Info</span>
              }
              @if (obj.article.lockText) {
                <span class="label label-danger">Sperre</span>
              }
            </td>
            <td>{{ obj.production.duration }}</td>
            <td>{{ obj.production.max_duration }}</td>
            <td>
              @if (index !== 0 && ('article.extra'|HasPerm)) {
                <button type="button" class="ev-button"
                  (click)="up(index, obj.article.ordering)">
                  <i class="fa fa-chevron-up"></i>
                </button>
              }
            </td>
            <td>
              @if (index !== articleProductionList.length - 1 && ('article.extra'|HasPerm)) {
                <button type="button" class="ev-button" (click)="down(index, obj.article.ordering)"
                  >
                  <i class="fa fa-chevron-down"></i>
                </button>
              }
            </td>
            <td>
              @if (('article.extra'|HasPerm)) {
                <button type="button" class="ev-button" (click)="edit(index, obj)">
                  <i class="fa fa-pencil"></i>
                </button>
              }
            </td>
            <td>
              @if (!obj.article.lockText && ('article.extra'|HasPerm)) {
                <button type="button" class="ev-button"
                  (click)="deleteStep(index, obj)"
                  >
                  <i class="fa fa-trash-o"></i>
                </button>
              }
            </td>
          </tr>
          <tr dnd-droppable [dropZones]="zones" (dropSuccessEmitter)="dropStep($event, index + 2)">
            <td colspan="8" style="padding: 0; border: none;">
              @if (dragging) {
                <div class="-mt-10 h-10 w-full"></div>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <form [formGroup]="form">
  <div class="col-md-4">
    <h4>Alle Fertigungsschritte</h4>
    <table class="table whitetable">
      <thead>
        <tr>
          <th style="width: 40px"></th>
          <th style="width: 50px">Nr.</th>
          <th>Bezeichnung</th>
        </tr>
        <tr class="filterrow">
          <th style="width: 40px"></th>
          <th style="width: 50px">
            <input type="text" class="form-control input-sm" formControlName="nr" />
          </th>
          <th>
            <input type="text" class="form-control input-sm" formControlName="name" />
          </th>
        </tr>
      </thead>
      @if (!('article.extra'|HasPerm)) {
        <tbody>
          @for (obj of productionStepListFiltered; track obj; let index = $index) {
            <tr>
              <td></td>
              <td>{{ obj.nr }}</td>
              <td>{{ obj.text }}</td>
            </tr>
          }
        </tbody>
      }
      @if (('article.extra'|HasPerm)) {
        <tbody>
          @for (obj of productionStepListFiltered; track obj; let index = $index) {
            <tr
              dnd-draggable
              [dropZones]="zones"
              [dragData]="{data: obj, typ: 'production_step'}"
              (dragStartEmitter)="dragStart($event)"
              (dragEndEmitter)="dragEnd($event)">
              <td>
                <button type="button" class="ev-button" (click)="create(obj.id)">
                  <i class="fa fa-chevron-left"></i>
                </button>
              </td>
              <td>{{ obj.nr }}</td>
              <td>{{ obj.text }}</td>
            </tr>
          }
        </tbody>
      }
    </table>
  </div>
  </form>

</div>

